export const CUSTOM_EVENTS = {
  logout: "logout",
};
